import { createSelector } from 'reselect';
import { RootState } from '../Common/store/rootReducer';
import { activeCTSlugSelector } from '../List/listSelectors';

const comparisonStateSelector = (state: RootState) => state.comparison;

export const comparisonSelectedUuidsSelector = createSelector(
    activeCTSlugSelector,
    comparisonStateSelector,
    (activeCTSlug, comparison) => {
        if (comparison.selected[activeCTSlug] === undefined) {
            return [];
        }
        return comparison.selected[activeCTSlug].map(
            selectedItem => selectedItem && selectedItem.uuid,
        );
    },
);

export const comparisonSelectedSelector = createSelector(
    activeCTSlugSelector,
    comparisonStateSelector,
    (activeCTSlug, comparison) => comparison.selected[activeCTSlug] || {},
);

export const selectedLengthSelector = createSelector(
    comparisonSelectedUuidsSelector,
    selected => selected.length,
);

export const comparisonSelectedItemsSelector = (state: RootState) =>
    state.comparison.items;

export const comparisonSelectedIsLoadingSelector = (state: RootState) =>
    state.comparison.isLoading;
